import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import addColIcon from "../../../../assets/icons/add_column.svg";
import SearchBar from "../../../../components/commonComponents/searchBar";
import Button from "../commonComponents/button";
import { Base64 } from "js-base64";
import CreateAudienceModal from "../audience/CreateAudienceModal";
// import Modal from "../commonComponents/modal";
import { Modal, Popover, Tooltip, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../components/commonComponents/modals/Header";
import RadioButton from "../../../../components/form/radio/RadioButton";
import {
  handleSingleColsAction,
  updateSingleContactDetails,
} from "../../../../reduxToolkit/crmSlice";
import {
  cityListApi,
  countryListApi,
  stateListApi,
  crmListShow,
  crmReportStatus,
  crmReportUserSeen,
  AudienceSetMembersRemove,
  AudienceSetMembersList,
  AudienceSetList,
  AudienceSetMoveMembers,
  AudienceSetDelete
} from "../../api/Api";
import { ModelHeadings, headingColor, lifeCycleStages, crmFontColor } from "../../constants";
import { contactFilters } from "../../constants/index";
import Tags from "./contact/Tags";
import { crmBulkTagAssign } from "../../api/Api";
import ToastMain from "../../../../components/commonComponents/toast/ToastMain";
import AddSingleContact from "./contactModel/AddSingleContact";
import UploadFromCsv from "./contactModel/UploadFromCsv";
import Chevron from "../../../../assets/customSVG/ChevronCrm";
import Options from "../../../../assets/customSVG/Options";
import Teams from "../../../../assets/customSVG/accounts/Teams";
import Tag from "../../../../assets/customSVG/Tag";
import Person from "../../../../assets/customSVG/Person";
import Download from "../../../../assets/customSVG/campaigns/Download";
import NotificationContext from "../../../../providers/NotificationProvider";
import { showSuccessToast, showErrorToast } from "../../../../components/commonComponents/gxAntdToast/toastUtils";
import CustomDelete from "../../../../assets/customSVG/CustomDelete";
import { cn } from "../../../../helper/cn";
import { useFeature, useFunction } from "../../../../hooks/useFeatureGating";
import { FEATURES, FUNCTIONS } from "../../../../constant/featureSlugs";
import PremiumUpgradeScreen from "../../../../components/commonComponents/PremiumUpgradeScreen/PremiumUpgradeScreen";


export const Search = ({
  setVisibleColumns,
  isFilter,
  setIsFilter,
  templateSearch,
  no,
  origins,
  setNewContactActive,
  importFrom,
  setImportFrom,
  continueLoader,
  setContinueLoader,
  viewListsShow,
  selectedItems = [],
  selectAll = false,
  crmCount,
  activeFilter,
  onAudienceUpdated,
  onAudienceCreated,
}) => {

  // Bulk tag management state
  const [isTagsDropdownOpen, setIsTagsDropdownOpen] = useState(false);

  // Search input state
  const [searchInput, setSearchInput] = useState(isFilter || "");
  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      try {
        setIsFilter(searchInput);
        if (typeof templateSearch === "function") {
          templateSearch(searchInput);
        }
      } catch (err) {
        console.error("Search debounce error", err);
      }
    }, 500); // 500ms debounce
    return () => clearTimeout(handler);
  }, [searchInput, setIsFilter, templateSearch]);

  const [selectOpen, setSelectOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [importStep, setImportStep] = useState(1);
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [isAudienceModalVisible, setIsAudienceModalVisible] = useState(false);
  const [locationFilter, setLocationFilter] = useState("");
  const [contactSources, setContactSources] = useState([]);
  const [value1, setValue1] = useState("");
  const [audienceSets, setAudienceSets] = useState([]);
  const [selectedAudienceSet, setSelectedAudienceSet] = useState(null);
  const [showMappingScreen, setShowMappingScreen] = useState(false);
  const [isMoveModalVisible, setIsMoveModalVisible] = useState(false);
  const [targetAudienceSet, setTargetAudienceSet] = useState(null);
  const [isMoving, setIsMoving] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [lifeCycle, setLifeCycle] = useState(lifeCycleStages);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);
  const [isRemoveConfirmVisible, setIsRemoveConfirmVisible] = useState(false);
  const [countryListss, setCountryListss] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [reportStatus, setReportStatus] = useState(true);
  const { currentBrand, featureFlags } = useSelector((state) => state.app);
  const isAudienceManagementSystemEnabled = featureFlags?.ams_feature;

  const { isEnabled: canUseAudienceSegmentation } = useFeature(FEATURES.AUDIENCE_SEGMENTATION);
  const { isEnabled: canUseBulkExport } = useFunction(FUNCTIONS.CRM_BULK_EXPORT);
  const { isEnabled: canUseBulkUpload } = useFunction(FUNCTIONS.CRM_BULK_UPLOAD);

  const [contactsFilters, setContactsFilters] = useState([...contactFilters]);
  const [response, setResponse] = useState([]);
  const [originID, setoriginID] = useState(null);
  const reportPollingRef = useRef(null);
  const notification = useContext(NotificationContext);

  const toggleTagsDropdown = () => {
    setIsTagsDropdownOpen(!isTagsDropdownOpen);
  };

  const stopReportPolling = useCallback(() => {
    if (reportPollingRef.current) {
      clearInterval(reportPollingRef.current);
      reportPollingRef.current = null;
    }
  }, []);

  const fetchReportStatus = useCallback(() => {
    if (!currentBrand?.brand_id) {
      stopReportPolling();
      return;
    }

    crmReportStatus(currentBrand?.brand_id)
      .then((res) => {
        if (res?.status === 200) {
          const report = res?.data?.crm_report;
          report ? setReportStatus(report?.user_seen) : setReportStatus(true);

          if (!report) {
            stopReportPolling();
            return;
          }

          if (report?.status === 10) {
            showSuccessToast(notification,"Report has been sent to your email, successfully");
            const payload = { crm_report_id: report?.id };
            crmReportUserSeen(currentBrand?.brand_id, payload).then((res) => {
              if (res?.status === 200) {
              }
            });
          } else if (report?.status === -1) {
            showErrorToast(notification,"Report has not been sent due to an error, please try again");
            const payload = { crm_report_id: report?.id };
            crmReportUserSeen(currentBrand?.brand_id, payload).then((res) => {
              if (res?.status === 200) {
              }
            });
          }
        } else {
          stopReportPolling();
        }
      })
      .catch(() => {
        stopReportPolling();
      });
  }, [currentBrand?.brand_id, notification, stopReportPolling]);

  const startReportPolling = useCallback(() => {
    if (!currentBrand?.brand_id) {
      stopReportPolling();
      return;
    }

    stopReportPolling();
    fetchReportStatus();
    reportPollingRef.current = setInterval(fetchReportStatus, 5000);
  }, [currentBrand?.brand_id, fetchReportStatus, stopReportPolling]);

  useEffect(() => {
    startReportPolling();

    return () => {
      stopReportPolling();
    };
  }, [startReportPolling, stopReportPolling]);

  function buildBulkActionPayload({
    brand_id,
    select_all,
    selectedIds = [],
    deselectedIds = [],
    tag_ids,
    filters,
    search,
    activeFilter,
    tag_action,
  }) {
    const payload = {
      brand_id,
      tag_action,
      select_all,
      contact_person_ids: select_all ? deselectedIds : selectedIds,
      tag_ids,
    };
    if (filters) payload.filters = filters;
    if (search) payload.search = search;

    if (activeFilter) {
      if (activeFilter.type === 'audience_set') {
        payload.type = activeFilter.type;
        payload.audience_set_id = activeFilter.id;
      } else {
        if (activeFilter.tag) payload.tag_id = activeFilter.id;
        if (activeFilter.user_name) payload.user_id = activeFilter.id;
        if (activeFilter.name) payload.contact_origin = activeFilter.name;
      }
    }

    return payload;
  }

  async function handleBulkTagAssign(selectedTagIds, tag_action = 'assign') {
    try {
      const currentBrandId = currentBrand?.brand_id;
      const selectedIds = selectedItems.filter(i => i.selected).map(i => i.id);
      const deselectedIds = selectedItems.filter(i => !i.selected).map(i => i.id);

      // Handle filters based on active filter type
      let filtersToUse;
      if (activeFilter?.type === 'audience_set') {
        filtersToUse = activeFilter.filters ? Base64.encode(JSON.stringify(activeFilter.filters)) : undefined;
      } else {
        filtersToUse = Object.keys(contactsFilters)?.length > 0 ? Base64.encode(JSON.stringify(contactsFilters)) : undefined;
      }

      const payload = buildBulkActionPayload({
        brand_id: currentBrandId,
        select_all: selectAll,
        selectedIds,
        deselectedIds,
        tag_ids: selectedTagIds,
        filters: filtersToUse,
        search: searchInput,
        activeFilter,
        tag_action,
      });

      const response = await crmBulkTagAssign(payload);

      if (response?.status === 200) {
        showSuccessToast(notification, tag_action === 'assign' ? "Tags assigned successfully!" : "Tags removed successfully!");
        // Refresh the contact list or update UI as needed
        if (onAudienceUpdated) onAudienceUpdated();
      } else {
        showErrorToast(notification, "Failed to update tags");
      }
    } catch (error) {
      console.error("Error assigning tags:", error);
      showErrorToast(notification, "Error updating tags. Please try again.");
    }
  }

  const [selectedLocation, setSelectedLocation] = useState({
    country: { name: "", id: null },
    state: { name: "", id: null },
    city: { name: "", id: null },
  });

  const { dynamicColumns, crmColumn } = useSelector((store) => store.crm);
  const [selectedColumns, setSelectedColumns] = useState(
    crmColumn.map((col) => col.id)
  );
  const [popoverVisible, setPopoverVisible] = useState(false);
  const handleVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  const dispatch = useDispatch();
  const { filters } = useSelector((store) => store.crm);

  // Report generation functions
  const generateReport = async () => {
    try {
      if (currentBrand?.brand_id) {
        const selectedIds = selectedItems.filter(i => i.selected).map(i => i.id);
        const deselectedIds = selectedItems.filter(i => !i.selected).map(i => i.id);

        // Check if either select all is true or at least one contact is selected
        if (!selectAll && selectedIds.length === 0) {
          showErrorToast(notification,"Please select at least one contact or enable select all");
          return;
        }

        if (activeFilter?.type === 'audience_set') {

          const filters =  Base64.encode(JSON.stringify(activeFilter?.filters))
          // Handle audience set report generation
          const res = await AudienceSetMembersList(
            currentBrand.brand_id,  // brandId
            `filters=${filters}`,  // filters
            activeFilter?.added_contact_person_ids,  // addedIds
            activeFilter?.removed_contact_person_ids,  // removedIds
            1,  // page
            crmCount,  // limit
            isFilter,  // search
            selectAll,  // select_all
            selectAll ? deselectedIds : selectedIds,  // contact_person_ids
            true  // send_report
          );
          if (res?.status === 200) {
            showSuccessToast(notification, "Audience set report has been sent to your email, shortly");
            startReportPolling();
          }
        } else {
          // Handle regular CRM list report generation
          const queryParams = {
            limit: crmCount,
            page: 1,
            search: isFilter,
            filters: Object.keys(filters)?.length > 0 ? filters : undefined,
            user_id: activeFilter?.user_name ? activeFilter?.id : undefined,
            contact_origin: activeFilter?.name ? activeFilter?.name : undefined,
            select_all: selectAll,
            contact_person_ids: selectAll ? deselectedIds : selectedIds,
            send_report: true,
          };
          const res = await crmListShow(currentBrand?.brand_id, queryParams);
          if (res?.status === 200) {
            showSuccessToast(notification, "Report has been sent to your email, shortly");
            startReportPolling();
          }
        }
      }
    } catch (error) {
      console.error("Error generating report:", error);
      showErrorToast(notification, "Failed to generate report. Please try again.");
    }
  };

  // Fetch audience sets
  const fetchAudienceSets = async () => {
    try {
      const response = await AudienceSetList(currentBrand?.brand_id);

      if (response?.data?.data) {
        // Filter out the current audience set if we're viewing one
        const filteredAudienceSets = activeFilter?.type === 'audience_set'
          ? response.data.data.filter(set => set.id !== activeFilter.id)
          : response.data.data;

        setAudienceSets(filteredAudienceSets);
      } else {
        setAudienceSets([]);
      }
    } catch (error) {
      console.error('Error fetching audience sets:', error);
      setAudienceSets([]);
    }
  };

  useEffect(() => {
    if (currentBrand?.brand_id) {
      fetchAudienceSets();
    } else {
      setAudienceSets([]);
    }
  }, [currentBrand?.brand_id, activeFilter?.id]);

  useEffect(() => {
    setContactSources(origins);
  }, [origins]);

  const handleSaveClick = () => {
    setActive(true);
    setNewContactActive(true);
  };

  const handleLocationClick = (type, name, id) => {
    setSelectedLocation((prev) => ({
      ...prev,
      [type]: { name, id },
    }));
    const dispatchAction = (key, value) => {
      dispatch(
        handleSingleColsAction({
          key,
          value,
          field: "address",
        })
      );
    };

    if (type === "country") {
      dispatchAction("country", id);
    } else if (type === "state") {
      dispatchAction("state", id);
    } else if (type === "city") {
      dispatchAction("city", id);
    }
    setPopoverVisible(false);
  };

  const countryLists = () => {
    countryListApi().then((res) => {
      if (res?.data) {
        setCountryListss(res?.data?.data);
      }
    });
  };

  const stateLists = () => {
    stateListApi(selectedLocation?.country?.id).then((res) => {
      if (res?.data) {
        setStateList(res?.data?.data);
      }
    });
  };

  const cityLists = () => {
    cityListApi(selectedLocation?.state?.id).then((res) => {
      if (res?.data) {
        setCityList(res?.data?.data);
      }
    });
  };

  useEffect(() => {
    if (active) {
      countryLists();
    }

    if (selectedLocation?.country?.id) {
      stateLists();
    }

    if (selectedLocation?.state?.id) {
      cityLists();
    }
  }, [
    importFrom,
    selectedLocation?.country?.id,
    selectedLocation?.state?.id,
    active,
  ]);

  const locationSearch = (value) => {
    setLocationFilter(value);
  };

  const handleColumnToggle = (id) => {
    const nonToggleIds = [1, 2, 3, 4, 6];

    if (nonToggleIds.includes(id)) {
      return;
    }

    setVisibleColumns((prevState) => {
      const column = crmColumn.find((col) => col.id === id);
      if (column) {
        return prevState.includes(column.label)
          ? prevState.filter((label) => label !== column.label)
          : [...prevState, column.label];
      }
      return prevState;
    });

    setSelectedColumns((prevState) => {
      if (prevState.includes(id)) {
        return prevState.filter((columnId) => columnId !== id);
      } else {
        return [...prevState, id];
      }
    });
  };

  const resetForm = () => {
    const singleContactUploadDetails = {
      contact: {
        first_name: "",
        last_name: "",
        phone_number: "",
        phone_number_code: "+91",
        email: "",
        alternative_mobile: [{ phone_number: "", phone_number_code: "+91" }],
        contact_origin: "",
        // life_cycle_stage: "",
        opted_out: [],
        whatsApp_opt_out: false,
        email_opt_out: false,
        SMS_opt_out: false,
        audience_set_id: "",
      },
      address: {
        address: "",
        country: "",
        state: "",
        city: "",
        "zip_code / postal_code": "",
      },
    };

    for (const field in singleContactUploadDetails) {
      for (const key in singleContactUploadDetails[field]) {
        dispatch(
          handleSingleColsAction({
            key: key,
            value: singleContactUploadDetails[field][key],
            field: field,
          })
        );
      }
    }

    dispatch(
      updateSingleContactDetails({
        access_name: "selected_tags",
        value: [],
      })
    );
    setContactSources([]);
    setValue1("");
    setIsButtonDisabled(false);
    setSelectedLocation({
      country: { name: "", id: null },
      state: { name: "", id: null },
      city: { name: "", id: null },
    });
    setContactsFilters([...contactFilters]);
    setResponse([]);
  };

  const Column = () => {
    return (
      <div className="country-popover1 flex-column w-100 bg-white max-h-[45vh] !min-w-[13vw] pl-10 pr-10 pt-20 pb-20  b-radius-6">
        <p className="py-[.3vh] px-[0.5vw] text-[.8vw] font-[500] rounded-md text-[var(--font-400)] ">
          Columns
        </p>
        {crmColumn?.map((item) => (
          <div
            className="w-100 bg-white pl-10 pr-10 pt-20 pb-20 text-[.8vw] font-[400] pointer flex-row align-center space-between"
            onClick={() => handleColumnToggle(item?.id)}
          >
            {item?.label}
            {selectedColumns.includes(item.id) && (
              <RadioButton selected={selectedColumns.includes(item.id)} />
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full border-b-[0.1vw] border-[var(--border-50)] p-[0.5vw] flex justify-between items-center overflow-hidden">
      {no && (
        <div className="w-[19.5vw] h-[2.1vw]">
          <SearchBar
            searchKey={searchInput}
            setSearchKey={setSearchInput}
            onChange={(text) => setSearchInput(text)}
            expandable={false}
          />
        </div>
      )}
      {!viewListsShow && (
        <div className="w-100 flex transition-all items-center align-end justify-end me-[1vw] gap-[.6vw]">
          {no && (
            <Popover
              placement="top"
              color={"black"}
              arrow={false}
              trigger="click"
              content={<Column />}
            >
              <Tooltip title={"Column"}>
                <img
                  src={addColIcon}
                  alt=""
                  className="hover:bg-gray-100 duration-200 cursor-pointer rounded-md me-[1vw]- size-[2.2vw]"
                />
              </Tooltip>
            </Popover>
          )}
          {/* <Button
            label="New Contact"
            // onClick={() => handleSaveClick()}
            classNames=" flex-row align-end justify-end !bg-[var(--new-primary)]"
          /> */}
          <Popover
            placement="bottomRight"
            trigger="click"
            overlayClassName="options-popover"
            open={isPopoverVisible}
            onOpenChange={setIsPopoverVisible}
            content={
              <div className="flex flex-col w-[200px] py-2 px-2">
                {/* New Contact */}
                <div
                  className="px-4 py-2 hover:bg-[#d8fdd2] cursor-pointer text-sm rounded-md flex-row align-center gap-2"
                  onClick={() => {
                    handleSaveClick();
                    setIsPopoverVisible(false);
                  }}
                >
                  <Person fill="var(--font-600)" width={20} height={20} />
                  New Contact
                </div>

                {/* Generate Report */}
                <Tooltip 
                  title={!canUseBulkExport ? "This feature is not available in your plan. Upgrade to access." : (!reportStatus ? "Report is generating, please wait" : "")} 
                  placement="bottom"
                >
                  <div 
                    className={cn(
                      "px-4 py-2 text-sm rounded-md flex-row align-center gap-2 transition-all",
                      (!canUseBulkExport || !reportStatus) ? 'opacity-50 cursor-not-allowed' : 'pointer hover:bg-[var(--new-primary-bg)]'
                    )}
                    onClick={() => {
                      if (canUseBulkExport && reportStatus) {
                        generateReport();
                      }
                    }}
                  >
                    <div className="flex flex-row align-center gap-2 items-center">
                      <Download fill="var(--font-600)" width={20} height={20} />
                      Download Report
                    </div>
                  </div>
                </Tooltip>

                {/* Add Tag */}
                <div className="px-4 py-2 relative hover:bg-[var(--new-primary-bg)]" style={{ zIndex: 1001 }}>
                  <Tags
                    className="right-0 top-[2vw] crm-dropdown"
                    Button={
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsPopoverVisible(false);
                        }}
                      >
                        <span className="duration-200 flex items-center cursor-pointer flex-row align-center gap-2">
                          <Tag fill={crmFontColor} />
                          Add Tag
                        </span>
                      </div>
                    }
                    zIndex={1002}
                    onConfirm={(tags, action) => {
                      handleBulkTagAssign(tags, action);
                      setIsPopoverVisible(false);
                    }}
                    selectedItems={selectedItems}
                    selectAll={selectAll}
                    totalSelectedCount={selectAll ? crmCount : selectedItems.filter(item => item.selected).length}
                  />
                </div>

                {/* Create Audience */}
                { isAudienceManagementSystemEnabled && <div
                  className="px-4 py-2 hover:bg-[#d8fdd2] cursor-pointer text-sm rounded-md flex-row align-center gap-2"
                  onClick={() => {
                    setIsPopoverVisible(false);
                    setIsAudienceModalVisible(true);
                  }}
                >
                  <Teams color="var(--font-600)" fillColors="var(--font-600)" />
                  Create Audience
                </div>}

                {/* Remove contact from Audience */}
                {isAudienceManagementSystemEnabled && activeFilter?.type === 'audience_set' && (
                  <div
                  className="px-2 py-2 hover:bg-[#d8fdd2] cursor-pointer text-sm rounded-md flex-row align-center gap-2"
                  onClick={() => {
                    const selectedContactIds = selectedItems.filter(item => item.selected).map(item => item.id);

                    if (selectedContactIds.length === 0 && !selectAll) {
                      showErrorToast(notification, "Please select at least one member to remove");
                      return;
                    }

                    if (selectAll && (!crmCount || crmCount === 0)) {
                      showErrorToast(notification, "No members available to remove");
                      return;
                    }

                    setIsRemoveConfirmVisible(true);
                  }}
                >
                    <CustomDelete width="1.2vw" height="1.2vw" color="var(--font-600)" fillColors="var(--font-600)" />
                    Remove Contact(s)
                  </div>
                )}

                {/* Move contact to Audience */}
                {isAudienceManagementSystemEnabled && audienceSets.length > 0 && (
                  <div
                    className="px-4 py-2 hover:bg-[#d8fdd2] cursor-pointer text-sm rounded-md flex-row align-center gap-2"
                    onClick={() => {
                      setIsPopoverVisible(false);
                      setIsMoveModalVisible(true);
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                    </svg>
                    Move Contact(s)
                  </div>
                )}

                {/* Delete Audience Set */}
                {isAudienceManagementSystemEnabled && activeFilter?.type === 'audience_set' && (
                  <div
                    className="px-2 py-2 hover:bg-[#d8fdd2] cursor-pointer text-sm rounded-md flex-row align-center gap-2"
                    onClick={() => {
                      setIsPopoverVisible(false);
                      setIsDeleteConfirmVisible(true);
                    }}
                  >
                    <CustomDelete width="1.2vw" height="1.2vw" color="var(--font-600)" fillColors="var(--font-600)" />
                    Delete Audience
                  </div>
                )}
              </div>
            }
          >
            <div className="flex-row align-center gap-2 pointer rounded-lg px-2 mr-10 bg-[var(--new-primary)]">
              <Options stroke="#ffffff" />
              <span className="text-white text-[0.8vw] font-[500] py-[0.4vw]">
                Actions
              </span>
              <Chevron color="#ffffff"/>
            </div>
          </Popover>

          {/* New Contact Modal */}
          <Modal
            open={active}
            afterOpenChange={(open) => {
              setActive(open);
              // setNewContactActive(false);
            }}
            styles={{content: {padding: 0}}}
            active={active}
            closable={false}
            width={"60%"}
            // height={"80%"}
            centered
            footer={null}
            wrapClassName={"bg-[#00000095]"}
            destroyOnClose={true}
          >
            <div className="flex-row  h-[75vh] w-100 ">
              <div className="space-y-[1.5vh] rounded-tl-2xl rounded-bl-2xl   bg-[#F4F6F8] border-[1px] border-r-[#E8E8EA] p-20 w-25">
                {Object.keys(ModelHeadings).map((item) => {
                  const { Icon, sideNavLabel } = ModelHeadings[item];
                  const isSelected = item === importFrom;
                  const isGated = item === 'csv' && !canUseBulkUpload;

                  return (
                    <Tooltip 
                      key={item} 
                      title={isGated ? "This feature is not available in your plan. Upgrade to access." : ""}
                      placement="right"
                    >
                      <div
                        onClick={() => {
                          if (!isGated) {
                            setImportFrom(item);
                            setImportStep(1);
                          }
                        }}
                        className={cn(
                          `flex gap-3 items-center py-[0.5vh] rounded-md px-[.5vw] text-[.8vw] font-[400] transition-all`,
                          isSelected ? "bg-[var(--new-primary)]" : (isGated ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-gray-200")
                        )}
                      >
                        <Icon
                          width={"1vw"}
                          fill={isSelected ? "#fff" : headingColor}
                        />
                        <p
                          className={cn(
                            "font14px-500",
                            isSelected ? "text-[var(--white)]" : "text-[var(--textBlack)]"
                          )}
                        >
                          {sideNavLabel}
                        </p>
                      </div>
                    </Tooltip>
                  );
                })}
              </div>
              <div className="w-80 overflow-hidden">
                <Header
                  title={showMappingScreen ? "Columns with matches" : (importFrom === "csv" ? "Import From File" : "Add Contact")}
                  className="font18px-600"
                  titleSize="none"
                  subTitleSize="none"
                  prefix={showMappingScreen ? (
                    <button
                      onClick={() => setShowMappingScreen(false)}
                      className="mr-2 text-gray-600 hover:text-gray-800"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19L8 12L15 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  ) : null}
                  handleCancel={() => {
                    setActive(false);
                    resetForm();
                    setNewContactActive(false);
                  }}
                />
                {importFrom === "csv" && (
                  <UploadFromCsv
                    selectOpen={selectOpen}
                    setSelectOpen={setSelectOpen}
                    importStep={importStep}
                    setImportStep={setImportStep}
                    contactSources={contactSources}
                    showMappingScreen={showMappingScreen}
                    setShowMappingScreen={setShowMappingScreen}
                    setContactSources={setContactSources}
                    setActive={setActive}
                    contactsFilters={contactsFilters}
                    setContactsFilters={setContactsFilters}
                    originID={originID}
                    setoriginID={setoriginID}
                    response={response}
                    setResponse={setResponse}
                    continueLoader={continueLoader}
                    setContinueLoader={setContinueLoader}
                    resetForm={resetForm}
                  />
                )}

                {importFrom === "contact" && (
                  <AddSingleContact
                    onClick={handleVisibleChange}
                    countryListss={countryListss}
                    popoverVisible={popoverVisible}
                    setPopoverVisible={setPopoverVisible}
                    stateList={stateList}
                    handleLocationClick={handleLocationClick}
                    cityList={cityList}
                    selectedLocation={selectedLocation}
                    setActive={setActive}
                    active={active}
                    isFilter={isFilter}
                    setIsFilter={setIsFilter}
                    templateSearch={templateSearch}
                    locationSearch={locationSearch}
                    locationFilter={locationFilter}
                    setLocationFilter={setLocationFilter}
                    resetForm={resetForm}
                    contactSources={contactSources}
                    setContactSources={setContactSources}
                    lifeCycle={lifeCycle}
                    setLifeCycle={setLifeCycle}
                    origins={origins}
                    setValue1={setValue1}
                    value1={value1}
                    setIsButtonDisabled={setIsButtonDisabled}
                    isButtonDisabled={isButtonDisabled}
                    audienceSets={audienceSets}
                    selectedAudienceSet={selectedAudienceSet}
                    setSelectedAudienceSet={setSelectedAudienceSet}
                  />
                )}
              </div>
            </div>
          </Modal>
        </div>
      )}

      {/* Create Audience Modal */}
      {canUseAudienceSegmentation ? (
        <CreateAudienceModal
          key={isAudienceModalVisible}
          visible={isAudienceModalVisible}
          onClose={() => setIsAudienceModalVisible(false)}
          onSuccess={() => {
            if (onAudienceCreated) {
              onAudienceCreated();
            }
          }}
        />
      ) : (
        <Modal
          open={isAudienceModalVisible}
          onCancel={() => setIsAudienceModalVisible(false)}
          footer={null}
          width={800}
          centered
          styles={{ content: { padding: 0 } }}
          destroyOnClose
        >
          <div className="p-10">
            <PremiumUpgradeScreen 
              title="Unlock Audience Segmentation"
              description="Segment your audience based on their behavior and property. Upgrade to a premium plan to access this feature."
              onUpgrade={() => {
                // Handle upgrade
                setIsAudienceModalVisible(false);
              }}
            />
          </div>
        </Modal>
      )}

      {/* Remove contacts Confirmation Modal */}
      <Modal
        title="Remove Contact(s) from Audience"
        open={isRemoveConfirmVisible}
        onCancel={() => {
          setIsRemoveConfirmVisible(false);
        }}
        footer={
          <div className="flex justify-end gap-2">
            <Button
              key="cancel"
              onClick={() => setIsRemoveConfirmVisible(false)}
              label="Cancel"
              classNames="mr-2"
            />
            <Button
              key="remove"
              type="primary"
              loading={isRemoving}
              onClick={async () => {
                try {
                  setIsRemoving(true);
                  const selectedContactIds = selectedItems.filter(item => item.selected).map(item => item.id);
                  const deselectedContactIds = selectedItems.filter(item => !item.selected).map(item => item.id);

                  const response = await AudienceSetMembersRemove(
                    currentBrand.brand_id,
                    {
                      id: activeFilter.id,
                      contact_person_ids: selectAll ? deselectedContactIds : selectedContactIds,
                      select_all: selectAll
                    }
                  );

                  if (response.status === 200) {
                    showSuccessToast(notification, "Members removed successfully");
                    // Refresh the audience data
                    if (onAudienceUpdated) {
                      const contactIds = selectAll ? deselectedContactIds : selectedContactIds;
                      onAudienceUpdated(selectAll && contactIds.length === 0);
                    } else {
                      onAudienceUpdated();
                    }
                    setIsRemoveConfirmVisible(false);
                  } else {
                    throw new Error('Failed to remove members');
                  }
                } catch (error) {
                  console.error('Error removing members:', error);
                  showErrorToast(notification, "Failed to remove members. Please try again.");
                } finally {
                  setIsRemoving(false);
                }
              }}
              label="Remove Contact(s)"
              classNames="bg-[var(--new-primary)] text-white"
            />
          </div>
        }
      >
        <div className="mb-4">
          <p className="text-gray-700">
            {selectAll && selectedItems.filter(item => !item.selected).length === 0
              ? `You are about to remove all ${crmCount} contacts from this audience.`
              : `Are you sure you want to remove ${selectAll
                  ? `${crmCount - selectedItems.filter(item => !item.selected).length} contact(s) from this audience?`
                  : `${selectedItems.filter(item => item.selected).length} selected contact(s) from this audience?`}`
            }
          </p>
          {selectAll && selectedItems.filter(item => !item.selected).length === 0 && (
            <p className="text-red-600 font-medium mt-2">
              By selecting all the contacts will delete the audience.
            </p>
          )}
        </div>
      </Modal>

      {/* Move contacts Confirmation Modal */}
      {canUseAudienceSegmentation ? (
      <Modal
        title="Move Contact(s) to Another Audience"
        open={isMoveModalVisible}
        onCancel={() => {
          setIsMoveModalVisible(false);
          setTargetAudienceSet(null);
        }}
        footer={
          <div className="flex justify-end gap-2">
            <Button
              key="cancel"
              onClick={() => {
                setIsMoveModalVisible(false);
                setTargetAudienceSet(null);
              }}
              label="Cancel"
              classNames="mr-2"
            />
            <Button
              key="move"
              type="primary"
              loading={isMoving}
              disabled={!targetAudienceSet || (selectedItems.filter(item => item.selected).length === 0 && !selectAll)}
              onClick={async () => {
              if (!targetAudienceSet) {
                showErrorToast(notification,"Please select a target audience set");
                return;
              }

              const selectedContactIds = selectedItems.filter(item => item.selected).map(item => item.id);
              const deselectedContactIds = selectedItems.filter(item => !item.selected).map(item => item.id);

              // If nothing is selected and not in selectAll mode, show warning and return
              if (selectedContactIds.length === 0 && !selectAll) {
                showErrorToast(notification,"Please select at least one member to move");
                return;
              }

              // If in selectAll mode but no members are available, show warning and return
              if (selectAll && (!crmCount || crmCount === 0)) {
                showErrorToast(notification,"No members available to move");
                return;
              }

              try {
                setIsMoving(true);
                const payload = {
                  source_audience_set_id: activeFilter?.type === 'audience_set' ? activeFilter?.id : undefined,
                  search: isFilter,
                  user_id: activeFilter?.user_name || undefined,
                  contact_origin: activeFilter?.contact_origin || undefined,
                  target_audience_set_id: targetAudienceSet,
                  contact_person_ids: selectAll ? deselectedContactIds : selectedContactIds,
                  select_all: selectAll,
                  filters: Object.keys(filters)?.length > 0 ? Base64.encode(JSON.stringify(filters)) : undefined,
                };

                const response = await AudienceSetMoveMembers(currentBrand?.brand_id, payload);

                if (response?.status === 200) {
                  showSuccessToast(notification,"Members moved successfully");
                  // Refresh the audience data
                  if (onAudienceUpdated) {
                    const contactIds = selectAll ? deselectedContactIds : selectedContactIds;
                    onAudienceUpdated(selectAll && contactIds.length === 0);
                  } else {
                    onAudienceUpdated();
                  }
                  setIsMoveModalVisible(false);
                  setTargetAudienceSet(null);
                } else {
                  showErrorToast(notification,"Failed to move members");
                }
              } catch (error) {
                console.error('Error moving members:', error);
                showErrorToast(notification,"Failed to move members. Please try again.");
              } finally {
                setIsMoving(false);
              }
            }}
              label="Move Contact(s)"
              classNames="bg-[var(--new-primary)] text-white"
            />
          </div>
        }
      >
        <div className="mb-4">
          <p className="mb-2">Select audience set</p>
          <Select
            className="w-full"
            placeholder="Select an audience set"
            value={targetAudienceSet}
            onChange={(value) => setTargetAudienceSet(value)}
            options={audienceSets.map(set => ({
              label: set.name,
              value: set.id
            }))}
          />
          <p className="mt-2 text-sm text-gray-500">
            {selectAll && selectedItems.filter(item => !item.selected).length === 0
              ? `All ${crmCount} contacts from this audience will be moved to the selected audience set.`
              : selectAll
                ? `${crmCount - selectedItems.filter(item => !item.selected).length} contact(s) will be moved to the selected audience set.`
                : `${selectedItems.filter(item => item.selected).length} selected contact(s) will be moved to the selected audience set.`
            }
          </p>
          {selectAll && selectedItems.filter(item => !item.selected).length === 0 && (
            <p className="text-amber-600 text-sm mt-2">
              This will move all contacts from this audience to the selected one and delete this audience.
            </p>
          )}
        </div>
      </Modal>) : (
        <Modal
          open={isMoveModalVisible}
          onCancel={() => {
            setIsMoveModalVisible(false);
            setTargetAudienceSet(null);
          }}
          footer={null}
          width={800}
          centered
          styles={{ content: { padding: 0 } }}
          destroyOnClose
        >
          <div className="p-10">
            <PremiumUpgradeScreen 
              title="Unlock Audience Segmentation"
              description="Move your contacts to another audience. Upgrade to a premium plan to access this feature."
              onUpgrade={() => {
                // Handle upgrade
                setIsMoveModalVisible(false);
              }}
            />
          </div>
        </Modal>
      )}

      {/* Delete Audience Confirmation Modal */}
      <Modal
        title="Delete Audience"
        open={isDeleteConfirmVisible}
        onCancel={() => {
          setIsDeleteConfirmVisible(false);
        }}
        footer={
          <div className="flex justify-end gap-2">
            <Button
              key="cancel"
              onClick={() => setIsDeleteConfirmVisible(false)}
              label="Cancel"
              classNames="mr-2"
            />
            <Button
              key="delete"
              type="primary"
              onClick={async () => {
                try {
                  const response = await AudienceSetDelete(currentBrand?.brand_id, {
                    id: activeFilter.id
                  });

                  if (response?.status === 200) {
                    showSuccessToast(notification, 'Audience deleted successfully');
                    setIsDeleteConfirmVisible(false);

                    // Refresh the audience list and reset to default view
                    if (onAudienceUpdated) {
                      onAudienceUpdated(true); // Pass true to reset the active filter
                    }
                  } else {
                    throw new Error('Failed to delete audience');
                  }
                } catch (error) {
                  console.error('Error deleting audience:', error);
                  showErrorToast(notification, 'Failed to delete audience. Please try again.');
                  setIsDeleteConfirmVisible(false);
                }
              }}
              label="Delete"
              classNames="bg-red-600 hover:bg-red-700 text-white"
            />
          </div>
        }
      >
        <div className="mb-4">
          <p className="text-gray-700">Are you sure you want to delete this audience? This action cannot be undone.</p>
        </div>
      </Modal>
    </div>
  );
};
